'use es6';

import { RaiseLoading } from '../../../../trap/LoadingTrap';
import PropTypes from 'prop-types';

/**
 * TODO: Remove all of raise loading and simplify it...
 */
import { jsx as _jsx } from "react/jsx-runtime";
const ReportLoading = props => /*#__PURE__*/_jsx("div", {
  className: "report-status-loading reporting-visualization-report",
  "data-status-id": "report-status-loading",
  "data-test-id": "reporting-visualization-report",
  children: /*#__PURE__*/_jsx(RaiseLoading, Object.assign({}, props))
});
ReportLoading.propTypes = {
  'data-test-id': PropTypes.string
};
export default ReportLoading;